import { render } from "./CoachFilter.vue?vue&type=template&id=13c1b7ea&scoped=true"
import script from "./CoachFilter.vue?vue&type=script&lang=js"
export * from "./CoachFilter.vue?vue&type=script&lang=js"

import "./CoachFilter.vue?vue&type=style&index=0&id=13c1b7ea&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-13c1b7ea"

export default script